import { useState, useContext, createContext } from "react"

const Context = createContext()

export const StyleProvider = ({ children }) => {
  const [isShownSidebarMobile, setIsShownSidebarMobile] = useState(false)
  const [isMobile] = useState(/iPhone|iPad|Android/i.test(navigator.userAgent))

  return (
    <Context.Provider value={{ isMobile, isShownSidebarMobile, setIsShownSidebarMobile }}>
      {children}
    </Context.Provider>
  )
}

export const useTheme = () => {}

export const useResponsive = () => {
  const { isShownSidebarMobile, setIsShownSidebarMobile, isMobile } = useContext(Context)
  return { isShownSidebarMobile, setIsShownSidebarMobile, isMobile }
}
